module.exports = __webpack_public_path__ + "img/etho.20111351.svg";